import styled from 'styled-components';

const AddTemplateStyled = styled.div`
  display: flex;
  .preview-wrapper {
    width: 443px;
    margin-left: 24px;
    background: #fff;
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.08);
    border-radius: 14px;
    border: 1px solid #1565c0;
    height: 802px;

    /* justify-content: center; */

    padding: 20px 10px;
    > div {
      height: 100%;
      display: flex;
      background-color: #f9f9f9;
      align-items: center;
      flex-direction: column;
    }
    /* padding: 32px; */
    .preview-text {
      height: 55px;
      /* margin-top: 20px;
      margin-left: 10px;
      margin-right: 10px; */
      display: flex;
      width: 423px;
      background-color: #ffff;
      color: #9e9e9e;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid #f5f5f5;
    }
    .rectangle {
      height: 80px;
      width: 375px;
      background-color: #ffff;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
    }
    .mobile-content {
      background-color: #ffff;
      box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.08);
      margin-top: 40px;
      width: 375px;
      min-height: 393px;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .gap {
        height: 52px;
        display: flex;
        font-size: 30px;
        color: #d8d8d8;
        padding: 0 24px;
        justify-content: flex-end;
        align-items: center;
        border-bottom: 1px solid #f6f7f7;
      }
    }
    .title {
      font-weight: 500;
      color: #212121;
      font-size: 20px;
      line-height: 28px;
      padding: 10px 24px;
    }
    .preview-content {
      padding: 0 24px;
      line-height: 48px;
      margin-bottom: 12px;
      color: #a0a0a0;
    }
    .mini-preview {
      color: #4f4f4f;
      padding: 0 24px;
      line-height: 48px;
      font-weight: 600;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      &::before {
        content: '';
        background-color: #f6f7f7;
        width: 327px;
        height: 1px;
        position: absolute;
        top: 0;
      }
    }
  }
  .label-require {
    color: #ff0000;
  }
  .label-name {
    color: #000;
    font-size: 14px;
  }
  .add-wrapper {
    border-radius: 14px;
    width: 695px;
    padding: 32px 40px;
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.08);
    background: #fff;
    .first-row {
      display: flex;
      gap: 48px;
      .MuiFormHelperText-root {
        margin-bottom: 8px;
      }
      .campaign-name {
        width: 320px;

        > div {
          width: 100%;
        }
      }
      .type {
        flex: 1;
        > div {
          width: 100%;
        }
      }
    }
    .second-row {
      margin-top: 32px;
      > div {
        width: 100%;
      }
    }
    .three-row {
      margin-top: 32px;
      display: flex;
      gap: 16px;
      align-items: center;
      .MuiFormControl-root {
        width: 447px;
      }
      .MuiFab-root {
        width: 90px;
        border-radius: 27px;
        height: 40px;
        color: #fff;
        .MuiSvgIcon-root {
          margin-right: 8px;
        }
      }
      .circle {
        width: 46px;
        height: 46px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: 1px solid #1565c0;
        position: relative;
        .color-input {
          position: absolute;
          height: 100%;
          width: 100%;
          opacity: 0;
          border: 1px solid red;
        }
        .MuiSvgIcon-root {
          width: 24px;
          height: 24px;
        }
      }
    }
    .remark-data {
      > div {
        width: 100%;
        margin-top: 32px;
      }
    }
    .appId-select {
      margin-top: 32px;
      > div {
        width: 100%;
      }
    }
    .page-path {
      margin-top: 32px;
      > div {
        width: 100%;
      }
    }
    .url {
      margin-top: 32px;
      > div {
        width: 100%;
      }
    }
  }
  .button-wrapper {
    height: 103px;
    background: #ffffff;
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.08);
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: 24px;
    padding: 0 40px;
    margin-top: 24px;
    .cancel {
      margin-right: 16px;
    }
  }
  .sketch-picker {
    border: 1px solid red;
  }
`;
const ModalStyled = styled.div`
  width: ${(props) => (props.type === 'colorSelect' ? 300 : 540)}px;
  padding: 24px 24px;
  .first-line {
    width: 100%;
    display: flex;
    gap: 48px;
    .show-data {
      padding: 0 32px;
      display: flex;
      font-size: 12px;
      color: #212121;
      justify-content: center;
      min-width: 120px;
      align-items: center;
      box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.08);
      border: ${(props) => (props?.keyField ? '1px solid #1565C0' : '')};
      border-radius: 14px;
      background-color: #f9f9f9;
    }
    .MuiFormControl-root {
      width: 270px;
    }

    margin-bottom: 64px;
  }
  .button-group {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .cancel {
      margin-right: 16px;
    }
  }
`;
export { AddTemplateStyled, ModalStyled };
